
var Route = require('./route');

var css = require("./styles/main.scss");
var ScrollMagic = require("ScrollMagic");
var key = require("keymaster");

require("photoswipe/dist/photoswipe.css");
require("photoswipe/dist/default-skin/default-skin.css"); 
var PhotoSwipe =    require("photoswipe/dist/photoswipe.js");
var PhotoSwipeUI =  require("photoswipe/dist/photoswipe-ui-default.js");

// var imagesLoaded = require('node_modules/imagesloaded/imagesloaded.pkgd.min.js');

/* 
 * Workaround for 1px lines appearing in some browsers due to fractional transforms
 * and resulting anti-aliasing.
 * https://github.com/Leaflet/Leaflet/issues/3575
 */
(function(){
    var originalInitTile = L.GridLayer.prototype._initTile
    L.GridLayer.include({
        _initTile: function (tile) {
            originalInitTile.call(this, tile);

            var tileSize = this.getTileSize();

            tile.style.width = tileSize.x + 1 + 'px';
            tile.style.height = tileSize.y + 1 + 'px';
        }
    });
})()


var app = {

    markers: {},

    initialize: function() {

        // initialize a few variables
        app.routeBounds = [[48.640728170257006,14.991597725108779], [2.2790618517710803,102.79357910156251]];
        app._$kmOutput = document.querySelector('.km_output .km');
        app.currentCountryIndex = 0;
        
        app.countryData = require("./country_data.json");
        app.viewportData = require("./viewports.json");

        // initialize map
        app.map  = L.map('map', {zoomSnap: 0.5}); //.setView([51.505, -0.09], 6);
        L.tileLayer('https://api.mapbox.com/styles/v1/mappinger/ciq8dyzac0085dvm4o2d3tyu4/tiles/256/{z}/{x}/{y}?access_token=pk.eyJ1IjoibWFwcGluZ2VyIiwiYSI6ImNpcHdrNmJ1eDAwNjdocWtzajh1YXMxMTUifQ.mMagd4TdSEsXQaVYMMRY8A', { 
            attribution: 'Map data &copy; <a href="http://openstreetmap.org">OpenStreetMap</a> contributors, <a href="http://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="http://mapbox.com">Mapbox</a>',
            maxZoom: 18,
            updateWhenIdle: true,
            reuseTiles: true,
            unloadInvisibleTiles: false,
            crossOrigin: true,
            detectRetina: false
        }).addTo(app.map);

        // for debug only
        window._map = app.map;
        window._app = app;

        app.map.zoomControl.remove();
        app.disableMap();

        app.map.on('click', function(event) {
            console.log(event.latlng);
        });

        app.map.on('popupopen', app.onPopupOpen);



        // fit to bounds
        window.setTimeout(function() {
            app.map.fitBounds(app.routeBounds);

            app.map.on("layeradd", app.onLayerAdd);
            app.polyline = L.polyline(Route, {color: '#cf0026', weight: 6, className: "routePath", noClip: true}).addTo(app.map).bringToBack();

        }, 10);

        // init markers
        //app.initMarkers();

        // initialize scroll container
        app.initializeScrollController();

        // scroll to top
        window.setTimeout(function() { window.scrollTo(0,0); });

        app.initKeyboard();

    },


    onLayerAdd: function() {
        app.map.off("layeradd", app.onLayerAdd);

        window.setTimeout(function() {

            app._$path = document.querySelector('svg path.routePath');
            app.$path = $(app._$path);
            app.pathLength = app._$path.getTotalLength();

            // set path length to 0
            app.$path.css('stroke-dasharray', app.pathLength).css('stroke-dashoffset', app.pathLength);

            // onScroll Event handler
            $(window).on('scroll', app.updatePath);

            app.map.on('movestart', app.mapZoomStart);
            app.map.on('moveend', app.mapZoomEnd);
        }, 1);

    },

    onPopupOpen: function(event) {
        var bgImage = event.popup.options.bgImage;
        $('.leaflet-popup-content-wrapper').css('background-image', 'url(' + bgImage + ')');

        $('.leaflet-popup-content').on('click', function() {
            app.openPhotoSwipe();
        });

    },

    storePath: function() {
        localStorage.setItem('path_latlngs', JSON.stringify(app.path_latlngs));
    },

    updatePath: function() {
        var top = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
        var topPercent = top / 28771;

        app.pathLength = app._$path.getTotalLength();

        var pLength = app.pathLength - app.pathLength * topPercent;
        app.$path.css('stroke-dasharray', app.pathLength).css('stroke-dashoffset', pLength + "px");

        var svgtop = app._$path.getPointAtLength(app.pathLength-pLength).y / app._$path.getPointAtLength(app.pathLength).y ;
        svgtop = 28771*svgtop;

        app._$kmOutput.innerText = parseInt(top).toLocaleString();
    },



    mapZoomStart: function() {
        app.$path.hide();

        //window._map.flyToBounds(window._app.viewportData[0].bounds)

    },

    mapZoomEnd: function() {
        
        if(app.afterZoomEndScrollTo) { 
            window.scrollTo(0,app.afterZoomEndScrollTo);
            app.afterZoomEndScrollTo = undefined;
        }

        window.setTimeout(function() {
            app.updatePath();
            app.$path.show();
        },100);

    },



    initializeScrollController: function() {
        // init controller
        app.scrollController = app.scrollController || new ScrollMagic.Controller();

        var scenes_data = app.countryData;

        var scenes = [];
        _.each(scenes_data, function(scene, index) {

            var selector = '.topbar ' + scene.selector;
            if(scenes_data[index+1]) var duration = scenes_data[index+1].offset - scene.offset;
            else var duration = 28771 - scene.offset + 1;

            scenes[scene.name] = new ScrollMagic.Scene({offset: scene.offset, duration: duration})
                            // .addIndicators({name: scene.name + " (offset: " + scene.offset + ", duration: " + scene.duration + ")"}) // add indicators (requires plugin)
                            .addTo(app.scrollController)
                            .on('enter', function(e) {
                                if(e.scrollDirection == "FORWARD") $(selector).attr('anim', 'in_up');
                                else $(selector).attr('anim', 'in_down');
                                app.currentCountry = scene.name;
                                app.currentCountryIndex = index;
                            })
                            .on('leave', function(e) {
                                if(e.scrollDirection == "FORWARD") $(selector).attr('anim', 'out_up');
                                else $(selector).attr('anim', 'out_down');
                            });

        });








        // build scene depending on a trigger element
    //  	var scene = new ScrollMagic.Scene({triggerElement: "#trigger1", duration: 200})
        //           		.addTo(controller)
        //           		.addIndicators() // add indicators (requires plugin)
        //           		.on("update", function (e) {
        //                       // console.log(e.target.controller().info('scrollDirection'));
        //           		})
        //           		.on("enter leave", function (e) {
        //                       console.log(e.type);
        //           			// $("#state").text(e.type == "enter" ? "inside" : "outside");
        //           		})
        //           		.on("start end", function (e) {
        //           			// $("#lastHit").text(e.type == "start" ? "top" : "bottom");
        //                       console.log(e.type);
        //           		})
        //           		.on("progress", function (e) {
        //           			// $("#progress").text(e.progress.toFixed(3));
        //           			// console.log(e.progress.toFixed(3));
        //           		});

        // create a scene depending on a pixel value
        // new ScrollMagic.Scene({
        //         duration: 100,    // the scene should last for a scroll distance of 100px
        //         offset: 50        // start this scene after scrolling for 50px
        //     })
        //     .setPin("#my-sticky-element") // pins the element for the the scene's duration
        //     .addTo(controller); // assign the scene to the controller





    },


    disableMap: function() {
        app.map.dragging.disable();
        app.map.touchZoom.disable();
        app.map.doubleClickZoom.disable();
        app.map.scrollWheelZoom.disable();
        app.map.boxZoom.disable();
        app.map.keyboard.disable();
        if (app.map.tap) app.map.tap.disable();
        document.getElementById('map').style.cursor='default';
    },


    enableMap: function() {
        app.map.dragging.enable();
        app.map.touchZoom.enable();
        app.map.doubleClickZoom.enable();
        app.map.scrollWheelZoom.enable();
        app.map.boxZoom.enable();
        app.map.keyboard.enable();
        if (app.map.tap) app.map.tap.enable();
        document.getElementById('map').style.cursor='grab';
    },


    openPhotoSwipe: function() {
        var pswpElement = document.querySelectorAll('.pswp')[0];

        // build items array
        var items = [
            {
                src: 'http://transasia.mgrubinger.at/wp-content/uploads/2016/04/IMG_3222.jpg',
                w: 1500,
                h: 1000
            },
            {
                src: 'https://placekitten.com/1200/900',
                w: 1200,
                h: 900
            }
        ];

        // define options (if needed)
        var options = {
            // optionName: 'option value'
            // for example:
            index: 0 // start at first slide
        };

        // Initializes and opens PhotoSwipe
        var gallery = new PhotoSwipe( pswpElement, PhotoSwipeUI, items, options);
        gallery.init();
    },




    initMarkers: function() {
        var markers_list = require("./markers.json");
        _.forEach(markers_list, function(marker_element) {

            // marker options
            var marker_options = {
                className: "marker",
                radius: 7,
                stroke: false,
                fill: true,
                fillColor: '#fff',
                fillOpacity: 1
            };

            // create marker
            var marker = L.circleMarker(L.latLng(marker_element.lat, marker_element.lng), marker_options).addTo(app.map);
            app.markers[marker_element.id] = marker;
            // bind popup
            marker.bindPopup("<div class='pop-title'><img src=''/>" + marker_element.title + "</div>", {offset: [0,60], popup_id: marker_element.id, bgImage: marker_element.image});
            window._m1 = marker;

            app.scrollController = app.scrollController || new ScrollMagic.Controller();
            new ScrollMagic.Scene({offset: marker_element.offset, duration: 0})
                            .addTo(app.scrollController)
                            .on('enter', function(e) {
                                if(e.scrollDirection == "FORWARD") TweenLite.to(marker._path, .5, {y: "-3px", opacity:1, ease: Back.easeOut.config(1.7)});
                            })
                            .on('leave', function(e) {
                                if(e.scrollDirection == "REVERSE") TweenLite.to(marker._path, .5, {y: "+3px", opacity:0, ease: Back.easeOut.config(1.7)});
                            });
        });

    },

    initKeyboard: function() {
        // key listener
        key('space', function(event){
            event.preventDefault();
            event.stopPropagation();
            // next country
            if(app.currentCountryIndex+1 <= app.countryData.length) {
                var next_country = app.countryData[app.currentCountryIndex+1 ];
                if(next_country == undefined) var next_country = {offset: 28772}
                var duration = (next_country.offset - window.scrollY) / 900;
                TweenLite.to(window, duration, {scrollTo: next_country.offset+1, ease: Power1.easeOut});
            }
        });


        app.charBuffer = "";
        document.addEventListener('keyup', function(event) {
            var char = String.fromCharCode(event.keyCode);
            app.charBuffer += char;
            var lastThree = app.charBuffer.substr(app.charBuffer.length - 3);

            if(lastThree == "000") {
                app.map.fitBounds(app.routeBounds);
                return;
            }

            // check if lastThree is in one of the viewports
            var vp = _.find(app.viewportData, function(el) {
                if(typeof el.pattern === "string" && el.pattern == lastThree) return true;
                else if(_.isArray(el.pattern)) {
                    if(el.pattern.indexOf(lastThree) !== -1) return true;
                } 
            });
            if(vp) {
                
                var country = _.find(app.countryData, {"name": vp.name});
                if(country) {
                    app.afterZoomEndScrollTo = country.offset;
                }

                app.map.flyToBounds(vp.bounds);
            }
        });
    }


};


app.initialize();
module.exports = app;



//////////////////
// WEBPACK FOOTER
// ./src/app.js
// module id = 1
// module chunks = 0